import React from "react";

import { InvestorSectionIcon } from "./InvestorMetricIcons";

export default function InvestorSectionHeading({
  icon,
  children,
  className = "investor-section__title",
  tag: Tag = "h3",
  style,
  iconSize = "default",
  id,
}) {
  return (
    <Tag id={id} className={className} style={style}>
      <span
        className={[
          "investor-section-heading",
          iconSize === "hero" ? "investor-section-heading--hero" : "",
        ]
          .filter(Boolean)
          .join(" ")}
      >
        {icon ? (
          <span className="investor-section-heading__icon" aria-hidden>
            <InvestorSectionIcon name={icon} />
          </span>
        ) : null}
        <span className="investor-section-heading__text">{children}</span>
      </span>
    </Tag>
  );
}
